/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState, useMemo, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error dependency missing types
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Form } from 'foundations-components/transitional/components/Form';
import EmailSelectInput from './EmailSelectInput';
import EmailRecipientSearchInput from './EmailRecipientSearchInput';
import { usageTracker } from '../../../utils/usageTracker';
import { useSendPaymentEmailMutation } from '../../../hooks/useSendPaymentEmailMutation';
import { createNewEmailOption } from '../../../utils/emails';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SendEmailModal = ({
  objectId,
  customerEmail,
  onClose
}) => {
  const [selectedOptions, setSelectedOptions] = useState(customerEmail ? [createNewEmailOption(customerEmail)] : []);

  // Either the Payment's objectId, or a refundId associated with the Payment
  const [selectedEmailId, setSelectedEmailId] = useState(objectId);
  const handleEmailChange = useCallback(({
    target: {
      value
    }
  }) => {
    setSelectedEmailId(value);
  }, []);
  const validEmails = useMemo(() => selectedOptions.reduce((acc, email) => {
    const address = email.address;
    if (EmailAddressPattern.test(address)) {
      return acc.concat(address);
    }
    return acc;
  }, []), [selectedOptions]);
  const [sendPaymentEmail, {
    loading
  }] = useSendPaymentEmailMutation({
    selectedEmailId,
    objectId,
    emails: validEmails,
    onSuccess: () => {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.sendEmailSuccessAlert"
        }),
        type: 'success'
      });
      const isReceiptEmail = selectedEmailId === objectId;
      usageTracker.track('paymentCRMSidebarUsage', {
        action: isReceiptEmail ? 'sendReceiptEmailSubmitClicked' : 'sendRefundEmailSubmitClicked'
      });
      onClose();
    },
    onError: () => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.sendEmailErrorTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.sendEmailErrorText"
        }),
        type: 'danger'
      });
    }
  });
  const handleSubmit = useCallback(() => {
    sendPaymentEmail();
  }, [sendPaymentEmail]);
  const onSelectedOptionChange = ({
    target: {
      value
    }
  }) => {
    setSelectedOptions(value);
  };
  return /*#__PURE__*/_jsx(Modal, {
    width: 500,
    "data-test-id": "send-email-modal",
    children: /*#__PURE__*/_jsxs(Form, {
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.sendReceipt"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(EmailSelectInput, {
          objectId: objectId,
          value: selectedEmailId,
          onChange: handleEmailChange
        }), /*#__PURE__*/_jsx(Text, {
          marginBlock: "200",
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.sendReceiptTo"
          })
        }), /*#__PURE__*/_jsx(EmailRecipientSearchInput, {
          selectedOptions: selectedOptions,
          onSelectedOptionChange: onSelectedOptionChange
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.invalidEmailsSubmitTooltip"
          }),
          disabled: validEmails.length === selectedOptions.length,
          "data-test-id": "send-email-disabled-tooltip",
          children: /*#__PURE__*/_jsx(LoadingButton, {
            "data-test-id": "submit-send-email-request",
            loading: loading,
            use: "primary",
            onClick: handleSubmit,
            disabled: validEmails.length < selectedOptions.length || !selectedOptions.length,
            failed: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.send"
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.cancel"
          })
        })]
      })]
    })
  });
};
export default SendEmailModal;